import React, {useState, useEffect } from 'react';
import Select from 'react-select';
import SweetAlert from 'react-bootstrap-sweetalert';
import { useNavigate } from 'react-router-dom';
import redirectURL from '../../redirectURL';
// import FileUploadField from './FileUploadField';
import './reportDialog.css'; // Custom styles for the dialog
import { getDecoder } from "../../common/utils";
import 'react-datepicker/dist/react-datepicker.css';
import DatePicker from 'react-datepicker';



// Component
const ReportIssueModal = ({ showModal, closeAddSlider, setSliderLoader }) => {
  const decipher = salt => {
    const textToChars = text => text.split('').map(c => c.charCodeAt(0));
    const applySaltToChar = code => textToChars(salt).reduce((a, b) => a ^ b, code);
    return encoded => encoded.match(/.{1,2}/g)
        .map(hex => parseInt(hex, 16))
        .map(applySaltToChar)
        .map(charCode => String.fromCharCode(charCode))
        .join('');
}
const decode = decipher("Z744cRBHYjQTsI6cOlNaUKbuEQF6MiEr")
var localStorageRole = (localStorage.getItem("role"));
var decodedRoleCase= decode(localStorageRole).toLowerCase();


  var [show, setShow] = useState(false);
  var [basicTitle, setBasicTitle] = useState('false');
  var [basicType, setBasicType] = useState('');
  const [loadShow, setLoadShow] = useState('show-n');

  const navigate = useNavigate();

  const [selectedIssue, setSelectedIssue] = useState(null);
  const [selectedSeverity, setSelectedSeverity] = useState(null);
  const [description, setDescription] = useState('');
  const [mobileNumber, setMobileNumber] = useState('');
  var [uploadDoc, setuploadDoc] = useState([]);
  const [issueOptions, setIssueOptions] = useState(null);
  const [severityOptions, setIssueSeverityOptions]=useState([
          {label:"Critical", value:"Critical"},
          {label:"High", value:"High"},
          {label:"Medium", value:"Medium"},        
          {label:"Low", value:"Low"},
          {label:"Normal", value:"Normal"},
      ])
  const [severityColor, setSeverityColor] = useState('#000');
  var [uploadFile, setUploadFile] = useState([]);
  
  
useEffect(() => {
        redirectURL.post("consignments/getCategoryTypes",{}).then((response)=>{
            try{
                if(response.data.status==="success"){
                    var data= response.data.category_types
                    var records = data[0].master_data
                    var typeOptionsList = records.map(e=>({label:e, value:e}))
                    
                    setIssueOptions(typeOptionsList)
                }
            }catch(error){
                console.log("Error getting data", error)
            }
        })
        // const fetchIssueSeverityTypeOptions = async () => {
        //     const params = {}; // Define any params your request needs
        //     try {
        //       const response = await redirectURL.post('/getIssueSeverityTypeOptions', params);
        //       console.log(response.data, 'success');
        //       const options = response.data.records.map((plant) => ({
        //         value: plant.severity_type_code,
        //         label: `${plant.severity_type_name}`,
        //         color: `${plant.color}`
        //       }));
        //       console.log(options, 'myoptions');
        //       setIssueSeverityOptions(options);
        //     } catch (error) {
        //       console.error('Failed to fetch plant options:', error);
        //     }
        //   };
        //   fetchIssueSeverityTypeOptions();
    }, [])
// useEffect(() => {
//   const fetchIssueTypeOptions = async () => {
//     const params = {}; // Define any params your request needs
//     try {
//       const response = await redirectURL.post('/getIssueTypeOptions', params);
//       console.log(response.data, 'success');
//       const options = response.data.records.map((plant) => ({
//         value: plant.issue_type_name,
//         label: `${plant.issue_type_name}`
//       }));
//       console.log(options, 'myoptions');
//       setIssueOptions(options);
//     } catch (error) {
//       console.error('Failed to fetch plant options:', error);
//     }
//   };
//   fetchIssueTypeOptions();

//   const fetchIssueSeverityTypeOptions = async () => {
//     const params = {}; // Define any params your request needs
//     try {
//       const response = await redirectURL.post('/getIssueSeverityTypeOptions', params);
//       console.log(response.data, 'success');
//       const options = response.data.records.map((plant) => ({
//         value: plant.severity_type_code,
//         label: `${plant.severity_type_name}`,
//         color: `${plant.color}`
//       }));
//       console.log(options, 'myoptions');
//       setIssueSeverityOptions(options);
//     } catch (error) {
//       console.error('Failed to fetch plant options:', error);
//     }
//   };
//   fetchIssueSeverityTypeOptions();
  
// }, []);


const [issueDetails, setIssueDetails] = useState({
  issueType: '',
  description: '',
  severity: '',
  email: localStorage.getItem('email'), // Assuming you can auto-capture this
  phoneNumber: '',
  createdDate: new Date(),
  ticket_status: "Open",
  is_processed: 0
});
const referenceNum = issueDetails.createdDate.toISOString().replace(/\D/g, '');
// console.log(referenceNum, 'referenceNum');

const closeAlert = () => {
  setShow(false);
  closeAddSlider()
  if(decodedRoleCase==="admin"){
    navigate('/applicationissues');
  }
  if (window.location.pathname === '/applicationissues') {
    // Reload the page if the condition matches
    window.location.reload();
  }

};

const onClickClose = () => {
  navigate('/');
};

const handleIssueChange = (selectedOption) => {
  // Update both local state and issueDetails state
  setSelectedIssue(selectedOption);
  const updatedIssueType = selectedOption ? selectedOption.value : '';
  setIssueDetails({ ...issueDetails, issueType: updatedIssueType });
};

const handleDescriptionChange = (event) => {
  console.log(event.target.value);
  setDescription(event.target.value);
  const updatedIssueType = event ? event.target.value : '';
  setIssueDetails({ ...issueDetails, description: updatedIssueType });
};

const handleSeverityChange = (selectedOption) => {
  setSeverityColor(selectedOption.color);
  // Update both local state and issueDetails state
  setSelectedSeverity(selectedOption);
  const updatedSeverity = selectedOption ? selectedOption.value : '';
  setIssueDetails({ ...issueDetails, severity: updatedSeverity });
};

var handleFileChange = (event) => {
  console.log("2183", event)

  setuploadDoc(event.target.files[0])
}

const handleInputChange = (e) => {
  const { name, value } = e.target;
  var isValidStart = /^[6-9][0-9]*$/;   
  if (value !== "" && isValidStart.test(value) && value.length <= 10) {
    setMobileNumber(value);    
  } else if (value === "") {
    setMobileNumber("");
  }
  setIssueDetails({ ...issueDetails, [name]: value });
};

const handleSubmit = async (e) => {
  setLoadShow("show-m")
  e.preventDefault();
  // Here, you would typically send the issueDetails to your backend server
  var formData2 = new FormData();
  formData2.append("uploadFile", uploadFile);
  formData2.append("issueType", issueDetails.issueType);
  formData2.append("description", issueDetails.description);
  formData2.append("severity", issueDetails.severity);
  // formData2.append("email", issueDetails.email);
  formData2.append("IssueCreatedBy",  getDecoder().email);
  formData2.append("phoneNumber", issueDetails.phoneNumber);
  formData2.append("referenceNum", referenceNum);
  formData2.append("createdDate", issueDetails.createdDate);
  formData2.append("ticketStatus", issueDetails.ticket_status);


  // await redirectURL.post('/triggeremail', {}).then((response) => {

  // })
 
      if(issueDetails.severity !=="" && issueDetails.issueType !==""){
                    try{
                        const resp = await redirectURL.post("/savereportdata", formData2, {
                                   headers: {
                                       'content-type': 'multipart/form-data',
                                       'Access-Control-Allow-Origin': "*",
                                       'Access-Control-Allow-Methods': 'POST',
                                       'Access-Control-Allow-Headers': 'Origin, Content-Type'
                                   }
                               });
                               
                           if (resp.data.status === 'Success') {
                               
                              //  document.getElementById("formFile").reset();
                                setLoadShow("show-n")
                               setSliderLoader("show-n")
                               setShow(true)
                               setBasicTitle(`Issue Reported with Id ${referenceNum}`)
                               setBasicType("success")
                               

                              
                           }
                           else if (resp.data.status === "fail") {
                            setLoadShow("show-n")
                            setShow(true)
                            setBasicTitle("Something went wrong, please try again")
                            setBasicType("danger")
                              setSliderLoader("show-n")
                           }
                           else {
                            setLoadShow("show-n")
                            setShow(true)
                            setBasicTitle("Something went wrong, please try again")
                            setBasicType("danger")
                                setSliderLoader("show-n")
                           }
                       }catch(err){
                           console.log(err)
                           setLoadShow("show-n")

                           setSliderLoader("show-n")
                       }
                }else{
                    setLoadShow("show-n")
                    setShow(true)
                    setBasicTitle("Something went wrong, please try again")
                    setBasicType("danger")

                    setSliderLoader("show-n")
                }
               
  setSelectedIssue(null);
  setSelectedSeverity(null);
  setDescription('');
  setMobileNumber('');
  setUploadFile('');
};



   // Default color
  // const handleSeverityChange = (selectedOption) => {
  //    // Update color based on selection
  // };

  if (!showModal) return null;


  const customOption = (props) => {
    const { data } = props;
    const Icon = data.icon;
    return (
      <components.Option {...props}>
        <Icon style={{ marginRight: 8 }} size={16} />
        {data.label}
      </components.Option>
    );
  };

  // const handleFileChange = (event) => {
  //   const file = event.target.files[0];
  //   console.log('File selected:', file);
  //   // Handle file logic
  // };

  const customStyles2 = {
    control: (provided) => ({
      ...provided,
      textAlign: 'left',
      minWidth: 240,
      fontSize:"13px"

      // margin: 8
    }),
    placeholder: (provided) => ({
      ...provided,
      textAlign: 'left', // Align placeholder text to the left
      fontSize:"12px"
    }),
    option: (provided, state) => ({
      ...provided,
      textAlign: 'left',
    // color: state.isSelected ? 'white' : 'black', // Changes text color to white when option is selected
    // backgroundColor: state.isFocused ? 'lightgray' : state.isSelected ? 'blue' : 'white', // Adds background color for focused state
    display: 'flex', // Keeps label and icon in line
    alignItems: 'center', // Centers the content vertically
    paddingLeft: 20, // Padding left for text and icon inside the option
    cursor: 'pointer', // **New Change**: Changes the cursor to a pointer on hover
    fontSize:"12px"

    }),
  };

  
  const customStyles = {
    control: (provided) => ({
      ...provided,
      textAlign: 'left', // Align text inside the control to the left
      minWidth: 240,
      fontSize:"13px"
      // margin: 8,
    }),
    option: (provided, state) => ({
      ...provided,
    //   color: state.isFocused ? 'white' : 'black',
    //   backgroundColor: state.isFocused ? state.data.color : 'transparent',
      textAlign: 'left', // Align text in the dropdown options to the left
      display: 'flex',
      alignItems: 'center',
      paddingLeft: 20,
      fontSize:"12px"
    }),
    singleValue: (provided) => ({
      ...provided,
      textAlign: 'left' // Align selected value text to the left
    }),
    placeholder: (provided) => ({
      ...provided,
      textAlign: 'left', // Align placeholder text to the left
      fontSize:"12px"

    })
  };
  const changeFileHandlerForUpload = (event) => {
    try {

        const files = event.target.files;
        

        if (files && files.length > 0) {
            const file = files[0];
            const fileType = file.type;

            // Define the allowed MIME types (PDF and images)
            const validTypes = ['application/pdf', 'image/jpeg', 'image/png', 'image/gif', 'image/bmp', 'image/webp'];

            // Check if the file type is valid
            if (!validTypes.includes(fileType)) {
                alert("Please select a valid PDF or image file.");
                setUploadFile(null);
                document.getElementById("uploadFile").value = ""; // Clear the input
                return; // Exit the function
            }

            // If the file is valid, proceed to set the document
            setUploadFile(files[0]);

            // Optional: If you want to add a size limit
            // if (file.size <= 102400) {
            //     setCustomerDocument1(files);
            //     setEpodDoc(file);
            // } else {
            //     setShow(true);
            //     setBasicTitle("File size exceeds 100KB");
            //     setBasicType("info");
            //     setCustomerDocument1(null);
            //     document.getElementById("customer_lr_doc").value = "";
            // }
        }
    } catch (e) {
        const fileInput = document.getElementById("customer_document_1");
        if (fileInput) {
            fileInput.value = "";
        } else {
            console.error("Element with ID 'customer_document_1' not found");
        }

        // document.getElementById("customer_document_1").value = "";
    }
};
  
  return (
    <div className='modalBackdrop'>
      <SweetAlert show={show} type={basicType} title={basicTitle} onConfirm={closeAlert}></SweetAlert>
      <div className='modalContainer' onClick={e => e.stopPropagation()}>
        <h3 className='modalHeader'> 
          <span className='reportIssueIcon'><i className="icofont icofont-warning-alt f-30"></i></span>
          Report Issue
        </h3>
        <form onSubmit={handleSubmit}>
          <div className='formRow'>
          <div className='reportissueform-field'>
            <label className='reportIssueLabel'>
              Issue Category
              <span style={{ color: "red", fontSize: "18px" }}>*</span>
            </label>

            <Select
            name="issueType"
            value={selectedIssue}
            onChange={handleIssueChange}
            options={issueOptions}
            placeholder="Select an Issue"
            isClearable
            isSearchable
            required={true}
            styles={customStyles2}
            // styles={{ container: (base) => ({ ...base, width: '100%', borderRadius: "10px" }) }}
            />
          </div>
          <div className='reportissueform-field'>
              <label className='reportIssueLabel'>
                Severity
                <span style={{ color: "red", fontSize: "18px" }}>*</span>
              </label>
              <Select
                          name="severitytype"
                          value={selectedSeverity}
                          onChange={handleSeverityChange}
                          options={severityOptions}
                          placeholder="Select Severity"  // Adjusted to match the function of the select
                          isClearable
                          isSearchable
                          required={true}
                          styles={customStyles}
                          // styles={{ container: (base) => ({ ...base, width: '100%' }) }}
                        />
            </div>
          </div>
          <div className='formRow'>

        
            
            {/* <div className='reportissueform-field'>
              <FileUploadField  handleFileChange={handleFileChange} />
            </div> */}
          </div>
          <div className='formRow'>
            <div className='reportissueform-field'>
              <label className='reportIssueLabel' style={{marginTop:"-30px"}}>Description 
              <span style={{ color: "red", fontSize: "18px" }}>*</span>
              </label>
              <textarea
                          name="description"
                          value={description}
                          onChange={handleDescriptionChange}
                          style={{marginBottom: "0px", borderRadius:"4px"}}
                          // style={{ marginBottom: "23px" }}
                          required
                          rows="3"
                          cols="60"
                        />
            </div>
          </div>
          <div className="formRow">
          <div className='reportissueform-field'>

                                        <label className="reportIssueLabel" style={{marginTop:"-10px"}}>Upload File (Optional)</label>
                                        
                                        <input type="file" name="uploadFile" id="uploadFile" className="form-control" accept=".pdf, image/*" onChange={changeFileHandlerForUpload} />
                                    </div>
                                    </div>
                                    <div className=''>
              <label className='reportIssueLabel'>Phone Number (Optional)</label>
              <input type="text" name="phoneNumber" placeholder='Enter Phone No' className="phone-input  f-12" autoComplete='off'
                
                value={mobileNumber} onChange={handleInputChange} style={{ width: '100%', height: '38px', marginBottom: "25px" }} />
              {/* <Input placeholder="Add Phone Number" /> */}
            </div>
            {/* <div className="formRow">
            <div className='reportissueform-field'>                      
                          <label className="reportIssueLabel mt-10p">
                                    Issue Created by.
                                </label>
                                <input
                                    type="text"
                                    value={getDecoder().email}
                                    // styles={customStyles2}
                                    style={{
                                        padding: "5px",
                                        border: "1px solid #ccc",
                                        borderRadius: "4px",
                                        backgroundColor: "#e7e7e7",
                                        fontSize:"14px"
                                    }}

                                    readOnly
                                    autoComplete='off'
                                />
                            </div>
                            </div> */}
                            {/* <div className="formRow">
                            <div className='reportissueform-field'>                                                               
                                                   <label className="reportIssueLabel" style={{marginTop:"-10px"}}>
                                                                                    Issue Created On
                                                                                </label>
                                                                                <div id="datepicker1">
                                                                                    <DatePicker
                                                                                        selected={new Date()}
                                                                                        // onChange={changeHandleDate1}
                                                                                        name="created_on"
                                                                                        className="datepicker-custom-ptl5 form-control"
                                                                                        dateFormat="dd-MM-yyyy HH:mm"
                                                                                        id="created_on"
                                                                                        autoComplete="off"
                                                                                        showTimeSelect
                                                                                        timeFormat="HH:mm"
                                                                                        timeIntervals={15} // Interval for time selection (e.g., 15-minute intervals)
                                                                                        timeCaption="Time"
                                                                                        styles={customStyles}

                                                                                    />
                                                                                </div>
                                                                                </div>
                                                                            </div> */}

          <div className='buttonContainer'>
            <button className='reportIssueButton' type="button" onClick={closeAddSlider}>Close</button>
            <button className='reportIssueButton' type="submit">Submit</button>
          </div>
        </form>
      </div>
      <div className={"dataLoad "+loadShow}></div>
            <div className={"dataLoadpageimg " + (loadShow)}>
                <div className="loader-box"><div className="loader-box"><div className="rotate dashed colored"></div></div></div>
            </div>
    </div>
  );
};

export default ReportIssueModal;